/**
 * Node modules
 */
import styled from 'styled-components';

/**
 * Private modules
 */
import { scale } from '../.private';

/**
 * Styled components
 */
export default styled.div`
  > div:first-child {
    align-items: center;
    background-color: rgba(52, 73, 94,1.0);
    border-top-left-radius: ${scale.major(1)}px;
    border-top-right-radius: ${scale.major(1)}px;
    color: white;
    display: flex;
    height: ${scale.major(5)}px;
    padding: ${scale.major(1)}px ${scale.major(2)}px;
  }
  > div:nth-child(2) {
    align-items: center;
    background-color: rgba(52, 73, 94,1.0);
    border-bottom: ${scale.minor(0.25)}px solid rgba(189, 195, 199, 1);
    border-top: ${scale.minor(0.25)}px solid rgba(189, 195, 199, 1);
    color: white;
    display: flex;
    height: ${scale.major(6)}px;
    justify-content: space-between;
    padding: ${scale.major(1)}px ${scale.major(2)}px;
    > div {
      align-items: center;
      display: flex;
      justify-content: center;
      width: auto;
      > img {
        border-radius: 50%;
        height: ${scale.major(3)}px;
        margin-left: 0;
        margin-right: ${scale.major(1)}px;
        width: ${scale.major(3)}px;
      }
    }
  }
  > div:nth-child(3) {
    align-items: center;
    border-bottom: ${scale.minor(0.25)}px solid rgba(189, 195, 199, 1);
    display: flex;
    justify-content: center;
    padding: ${scale.major(1)}px ${scale.major(2)}px;
  }
  > div:nth-child(4) {
    border-bottom: ${scale.minor(0.25)}px solid rgba(189, 195, 199, 1);
    padding: ${scale.major(1)}px ${scale.major(2)}px;
  }
`;
